/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketsoffsale2Inputs */

const en_ticketsoffsale2 = /** @type {(inputs: Ticketsoffsale2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Off sale`)
};

const de_ticketsoffsale2 = /** @type {(inputs: Ticketsoffsale2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nicht im Verkauf`)
};

/**
* | output |
* | --- |
* | "Off sale" |
*
* @param {Ticketsoffsale2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketsoffsale2 = /** @type {((inputs?: Ticketsoffsale2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketsoffsale2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketsoffsale2(inputs)
	return de_ticketsoffsale2(inputs)
});
export { ticketsoffsale2 as "ticketsOffSale" }